module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-2-Landing-Page-w540.32233d8a.jpg";